import StandardPieChart from '../shared/QSightPieChart/StandardPieChart';

const sampleData = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
    { name: 'Group C', value: 300 },
    { name: 'Group D', value: 200 },
  ];

  const handleSliceClick = (entry: { name: string; value: number }, index: number) => {
    alert(`Clicked on ${entry.name} with value ${entry.value}`);
 };
 
const PieChartComponentDemo : React.FC = () => {
  return (
    <div className="pie-chart-section">
       <StandardPieChart data={sampleData} onClick={handleSliceClick} />
    </div>
  );
};



export default PieChartComponentDemo;